import MatestackUiVueJs from "matestack-ui-vuejs";

const euroValueInput = {
  mixins: [MatestackUiVueJs.componentMixin, MatestackUiVueJs.formInputMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,

  data() {
    return {
      euroValue: '10.00'
    }
  },
  methods: {
    preventValidationSkips: function() {

    },

    notifyEuroValueUpdate: function() {
      const self = this

      MatestackUiVueJs.eventHub.$emit("euro-value-modified", {euroValue: self.euroValue}) 
    }
  },
  mounted(){
    const self = this

    self.notifyEuroValueUpdate()
  }

}

export default euroValueInput